import { CheckoutHOC } from 'routes/Checkout';
import Checkout from '../components/Checkout';

export default CheckoutHOC(Checkout);
